import {
  keapMaxIcon,
  reverseGreenPlusIcon,
  reverseOrangePlusIcon,
} from '../assets'

export const SCORE_TEXTS = [
  'Excellent!',
  'You are almost there!',
  'You can do better!',
  'Oops, an error occured with the scan!',
]

export const SCORE_COLORS = ['#16A085', '#FFB800', '#DF2A2A', '#057AFF']

export const SCORE_CLASS_NAMES = [
  'score-primary',
  'score-warning',
  'score-error',
]

export const AUTHORIZED_ROLES_BY_SCREENS = {
  allAccount: [
    'admin',
    'clientcare',
    'leadconverter',
    'inside',
    'premise',
    'national',
    'thryvonly',
    'tss',
    'premisedemo',
    'insidedemo',
    'insidedemoonly',
    'premisepilot',
    'vivialdemo',
    'directsales',
    'partnerops',
  ],
  demoRequests: [
    'admin',
    'clientcare',
    'leadconverter',
    'inside',
    'premise',
    'national',
    'yello',
    'premisedemo',
    'insidedemo',
    'insidedemoonly',
    'premisepilot',
    'vivialdemo',
    'australia',
    'newzealandsales',
    'tss',
    'directsales',
  ],
  appointments: [
    'admin',
    'clientcare',
    'leadconverter',
    'inside',
    'premise',
    'national',
    'yello',
    'premisedemo',
    'insidedemo',
    'insidedemoonly',
    'premisepilot',
    'vivialdemo',
    'australia',
    'newzealandsales',
    'directsales',
  ],
  couponsConfiguration: ['admin'],
  myBuyNowLinks: ['partnerops', 'admin'],
  adminClientCenter: ['partnerops', 'admin'],
  bundleCouponReport: ['admin'],
}

export const ADDONS_TYPES = {
  SELECTED_PLAN: 'selectedPlan',
  ADD_ON: 'addon',
  ENTITLEMENTS: 'entitlements',
  ONE_TIME: 'oneTime',
  TOTAL: 'total',
}

export const MC_2_0_PLANS = [
  'mc_starter-5-thryv-m2m',
  'mc_prov2-5-thryv-m2m',
  'mc_premier-5-thryv-m2m',
  'starter-5-thryv-annual',
  'signature-5-thryv-annual',
  'premier-5-thryv-annual',
  'signature_plus-5-thryv-m2m',
  'signature_plus-5-thryv-annual',
]

// Both -4- and -5- codes: gates the checkIfHasNeededFlag gap in centers-and-apps.js.
export const GEO_ADDON_CODES = [
  'addon-geoadd-local-4-m2m',
  'addon-geoadd-metro-4-m2m',
  'addon-geoadd-state-4-m2m',
  'addon-geoadd-nation-4-m2m',
  'addon-geoadd-local-5-m2m',
  'addon-geoadd-metro-5-m2m',
  'addon-geoadd-state-5-m2m',
  'addon-geoadd-nation-5-m2m',
]

export const MC_2_0_STARTERPLANS = [
  'mc_starter-5-thryv-m2m',
  'starter-5-thryv-annual',
]

export const MC_2_0_SIGPREMIERPLANS = [
  'mc_prov2-5-thryv-m2m',
  'mc_premier-5-thryv-m2m',
  'signature-5-thryv-annual',
  'premier-5-thryv-annual',
  'signature_plus-5-thryv-annual',
  'signature_plus-5-thryv-m2m',
]

export const MC_2_0_SIGNATUREPLANS = [
  'mc_prov2-5-thryv-m2m',
  'signature-5-thryv-annual',
  'signature_plus-5-thryv-annual',
  'signature_plus-5-thryv-m2m',
]

export const MC_2_0_PREMIERPLANS = [
  'mc_premier-5-thryv-m2m',
  'premier-5-thryv-annual',
]

export const MC_2_0_MONTHLY_PLANS = [
  'mc_starter-5-thryv-m2m',
  'mc_prov2-5-thryv-m2m',
  'mc_premier-5-thryv-m2m',
  'signature_plus-5-thryv-m2m',
]

export const MC_2_0_ANNUAL_PLANS = [
  'starter-5-thryv-annual',
  'signature-5-thryv-annual',
  'premier-5-thryv-annual',
  'signature_plus-5-thryv-annual',
]

export const MC_2_0_NON_STARTER_ANNUAL_PLANS = [
  'signature-5-thryv-annual',
  'premier-5-thryv-annual',
  'signature_plus-5-thryv-annual',
]

export const THRYV_SUCCESS_SERVICES_CODES = [
  'addon-4-stratcontent-m2m',
  'addon-4-listrefrsh-m2m',
]

export const CC_THRYV_SUCCESS_SERVICES_CODES = [
  'addon-5-stratcontent-m2m',
  'addon-5-listrefrsh-m2m',
]

export const BILLING_PREFERENCES = ['monthly', 'semiAnnually', 'oneTime']

export const SEO_MBG_PRICES = {
  USA: [
    {name: '$250', value: 250},
    {name: '$400', value: 400},
    {name: '$600', value: 600},
    {name: '$800', value: 800},
    {name: '$1000', value: 1000},
    {name: '$1200', value: 1200},
    {name: '$1400', value: 1400},
    {name: '$1600', value: 1600},
    {name: '$1800', value: 1800},
    {name: '$2500', value: 2500},
    {name: '$3000', value: 3000},
    {name: '$3500', value: 3500},
    {name: '$4000', value: 4000},
    {name: '$4500', value: 4500},
    {name: '$5000', value: 5000},
    {name: '$5500', value: 5500},
    {name: '$6000', value: 6000},
    {name: '$6500', value: 6500},
    {name: '$7000', value: 7000},
    {name: '$8000', value: 8000},
    {name: '$9000', value: 9000},
    {name: '$10000', value: 10000},
    {name: '$11000', value: 11000},
    {name: '$12000', value: 12000},
    {name: '$13000', value: 13000},
    {name: '$14000', value: 14000},
    {name: '$15000', value: 15000},
  ],
  CAN: [
    {name: '$325', value: 325},
    {name: '$520', value: 520},
    {name: '$780', value: 780},
    {name: '$1040', value: 1040},
    {name: '$1300', value: 1300},
    {name: '$1560', value: 1560},
    {name: '$1820', value: 1820},
    {name: '$2080', value: 2080},
    {name: '$2340', value: 2340},
    {name: '$3250', value: 3250},
    {name: '$3900', value: 3900},
    {name: '$4550', value: 4550},
    {name: '$5200', value: 5200},
    {name: '$5850', value: 5850},
    {name: '$6500', value: 6500},
    {name: '$7800', value: 7800},
    {name: '$9100', value: 9100},
  ],
  AUS: [
    {name: '$227.27', value: 227},
    {name: '$337.5', value: 338},
    {name: '$540', value: 540},
    {name: '$810', value: 810},
    {name: '$909.09', value: 909},
    {name: '$1080', value: 1080},
    {name: '$1350', value: 1350},
    {name: '$1620', value: 1620},
    {name: '$1890', value: 1890},
    {name: '$2160', value: 2160},
    {name: '$2430', value: 2430},
    {name: '$3375', value: 3375},
    {name: '$3712.5', value: 3713},
    {name: '$4050', value: 4050},
    {name: '$4387.5', value: 4388},
    {name: '$4725', value: 4725},
    {name: '$5062.5', value: 5063},
    {name: '$5400', value: 5400},
    {name: '$5737.5', value: 5738},
    {name: '$6075', value: 6075},
    {name: '$6412.5', value: 6413},
    {name: '$6750', value: 6750},
    {name: '$8100', value: 8100},
    {name: '$9450', value: 9450},
  ],
}

export const CURRENCYS = {
  usa: 'USD',
  can: 'CAD',
  aus: 'AUD',
  barbados: 'USD',
  cayman: 'USD',
  gb: 'GBP',
  spain: 'USD',
  italy: 'USD',
  india: 'USD',
  philippines: 'USD',
  vietnam: 'USD',
  greece: 'USD',
}

export const CC_CURRENCIES = {
  usa: 'USD',
  can: 'CAD',
  aus: 'AUD',
  barbados: 'BBD',
  cayman: 'KYD',
  nz: 'NZD',
  gb: 'GBP',
  spain: 'USD',
  italy: 'USD',
  india: 'USD',
  philippines: 'USD',
  vietnam: 'USD',
  greece: 'USD',
}

// GST-inclusive gross-up factors (keyed by ISO country) for markets where
// catalog prices are displayed GST-inclusive. Used to render fixed-amount
// coupon discounts — returned tax-exclusive by Recurly — in the same
// GST-inclusive terms as the prices they offset. AU GST = 10%.
export const GST_MULTIPLIERS = {
  AU: 1.1,
}

export const COUNTRIES = {
  US: {name: 'United States', value: 'usa', isoValue: 'US'},
  AU: {name: 'Australia', value: 'aus', isoValue: 'AU'},
  KY: {
    name: 'Cayman Islands',
    value: 'cayman',
    isoValue: 'KY',
  },
  BB: {name: 'Barbados', value: 'barbados', isoValue: 'BB'},
  CA: {name: 'Canada', value: 'can', isoValue: 'CA'},
  NZ: {name: 'New Zealand', value: 'nz', isoValue: 'NZ'},
  GB: {name: 'Great Britain', value: 'gb', isoValue: 'GB'},
  ES: {name: 'Spain', value: 'spain', isoValue: 'ES'},
  IT: {name: 'Italy', value: 'italy', isoValue: 'IT'},
  IN: {name: 'India', value: 'india', isoValue: 'IN'},
  PH: {name: 'Philippines', value: 'philippines', isoValue: 'PH'},
  VN: {name: 'Vietnam', value: 'vietnam', isoValue: 'VN'},
  GR: {name: 'Greece', value: 'greece', isoValue: 'GR'},
}

export const SEO_BOTH_PLANS = ['unlimited', 'professional']

export const SEO_NG_PLANS = ['plus', 'sync']

export const CC_PLANS = [
  'my account pro',
  'my account plus',
  'business center',
  'marketing center',
]

export const TRANSITION_INCENTIVES = [
  {
    title: 'Month 1',
    subtitle: '(Incentive: 75%)',
    discount: 0.75,
  },
  {
    title: 'Month 2',
    subtitle: '(Incentive: 50%)',
    discount: 0.5,
  },
  {
    title: 'Month 3',
    subtitle: '(Incentive: 25%)',
    discount: 0.25,
  },
  {
    title: 'Month 4+',
  },
]

export const LIST_OF_STATES = [
  {
    name: 'Alabama',
    value: 'AL',
  },
  {
    name: 'Alaska',
    value: 'AK',
  },
  {
    name: 'Arizona',
    value: 'AZ',
  },
  {
    name: 'Arkansas',
    value: 'AR',
  },
  {
    name: 'California',
    value: 'CA',
  },
  {
    name: 'Colorado',
    value: 'CO',
  },
  {
    name: 'Connecticut',
    value: 'CT',
  },
  {
    name: 'Delaware',
    value: 'DE',
  },
  {
    name: 'District of Columbia',
    value: 'DC',
  },
  {
    name: 'Florida',
    value: 'FL',
  },
  {
    name: 'Georgia',
    value: 'GA',
  },
  {
    name: 'Hawaii',
    value: 'HI',
  },
  {
    name: 'Idaho',
    value: 'ID',
  },
  {
    name: 'Illinois',
    value: 'IL',
  },
  {
    name: 'Indiana',
    value: 'IN',
  },
  {
    name: 'Iowa',
    value: 'IA',
  },
  {
    name: 'Kansas',
    value: 'KS',
  },
  {
    name: 'Kentucky',
    value: 'KY',
  },
  {
    name: 'Louisiana',
    value: 'LA',
  },
  {
    name: 'Maine',
    value: 'ME',
  },
  {
    name: 'Maryland',
    value: 'MD',
  },
  {
    name: 'Massachusetts',
    value: 'MA',
  },
  {
    name: 'Michigan',
    value: 'MI',
  },
  {
    name: 'Minnesota',
    value: 'MN',
  },
  {
    name: 'Mississippi',
    value: 'MS',
  },
  {
    name: 'Missouri',
    value: 'MO',
  },
  {
    name: 'Montana',
    value: 'MT',
  },
  {
    name: 'Nebraska',
    value: 'NE',
  },
  {
    name: 'Nevada',
    value: 'NV',
  },
  {
    name: 'New Hampshire',
    value: 'NH',
  },
  {
    name: 'New Jersey',
    value: 'NJ',
  },
  {
    name: 'New Mexico',
    value: 'NM',
  },
  {
    name: 'New York',
    value: 'NY',
  },
  {
    name: 'North Carolina',
    value: 'NC',
  },
  {
    name: 'North Dakota',
    value: 'ND',
  },
  {
    name: 'Ohio',
    value: 'OH',
  },
  {
    name: 'Oklahoma',
    value: 'OK',
  },
  {
    name: 'Oregon',
    value: 'OR',
  },
  {
    name: 'Pennsylvania',
    value: 'PA',
  },
  {
    name: 'Rhode Island',
    value: 'RI',
  },
  {
    name: 'South Carolina',
    value: 'SC',
  },
  {
    name: 'South Dakota',
    value: 'SD',
  },
  {
    name: 'Tennessee',
    value: 'TN',
  },
  {
    name: 'Texas',
    value: 'TX',
  },
  {
    name: 'Utah',
    value: 'UT',
  },
  {
    name: 'Vermont',
    value: 'VT',
  },
  {
    name: 'Virginia',
    value: 'VA',
  },
  {
    name: 'Washington',
    value: 'WA',
  },
  {
    name: 'West Virginia',
    value: 'WV',
  },
  {
    name: 'Wisconsin',
    value: 'WI',
  },
  {
    name: 'Wyoming',
    value: 'WY',
  },
  {
    name: 'Alberta',
    value: 'AB',
  },
  {
    name: 'British Columbia',
    value: 'BC',
  },
  {
    name: 'Manitoba',
    value: 'MB',
  },
  {
    name: 'New Brunswick',
    value: 'NB',
  },
  {
    name: 'Newfoundland and Labrador',
    value: 'NL',
  },
  {
    name: 'Northwest Territories',
    value: 'NT',
  },
  {
    name: 'Nova Scotia',
    value: 'NS',
  },
  {
    name: 'Nunavut',
    value: 'NU',
  },
  {
    name: 'Ontario',
    value: 'ON',
  },
  {
    name: 'Prince Edward Island',
    value: 'PE',
  },
  {
    name: 'Quebec',
    value: 'QC',
  },
  {
    name: 'Saskatchewan',
    value: 'SK',
  },
  {
    name: 'Yukon',
    value: 'YT',
  },
  {
    name: 'Australian Capital Territory',
    value: 'ACT',
  },
  {
    name: 'New South Wales',
    value: 'NSW',
  },
  {
    name: 'Northern Territory',
    value: 'NT',
  },
  {
    name: 'Queensland',
    value: 'QLD',
  },
  {
    name: 'South Australia',
    value: 'SA',
  },
  {
    name: 'Tasmania',
    value: 'TAS',
  },
  {
    name: 'Victoria',
    value: 'VIC',
  },
  {
    name: 'Western Australia',
    value: 'WA',
  },
  {
    name: 'Auckland Region',
    value: 'AUK',
  },
  {
    name: 'Bay of Plenty region',
    value: 'BOP',
  },
  {
    name: 'Canterbury',
    value: 'CAN',
  },
  {
    name: 'Chatham Islands',
    value: 'Chatham Islands',
  },
  {
    name: 'Gisborne region',
    value: 'GIS',
  },
  {
    name: "Hawke's Bay region",
    value: 'HKB',
  },
  {
    name: 'Manawatu-Wanganui',
    value: 'MWT',
  },
  {
    name: 'Marlborough Region',
    value: 'MBH',
  },
  {
    name: 'Nelson',
    value: 'NSN',
  },
  {
    name: 'Northland region',
    value: 'NTL',
  },
  {
    name: 'Otago',
    value: 'OTA',
  },
  {
    name: 'Southland',
    value: 'STL',
  },
  {
    name: 'Taranaki',
    value: 'TKI',
  },
  {
    name: 'Tasman District',
    value: 'TAS',
  },
  {
    name: 'Waikato',
    value: 'WKO',
  },
  {
    name: 'Wellington Region',
    value: 'WGN',
  },
  {
    name: 'West Coast',
    value: 'WTC',
  },
  {
    name: 'West Coast',
    value: 'WTC',
  },
  {
    name: 'Christ Church',
    value: '01',
  },
  {
    name: 'Saint Andrew',
    value: '02',
  },
  {
    name: 'Saint George',
    value: '03',
  },
  {
    name: 'Saint James',
    value: '04',
  },
  {
    name: 'Saint John',
    value: '05',
  },
  {
    name: 'Saint Joseph',
    value: '06',
  },
  {
    name: 'Saint Lucy',
    value: '07',
  },
  {
    name: 'Saint Michael',
    value: '08',
  },
  {
    name: 'Saint Peter',
    value: '09',
  },
  {
    name: 'Saint Philip',
    value: '10',
  },
  {
    name: 'Saint Thomas',
    value: '11',
  },
  {
    name: 'Bodden Town',
    value: 'Bodden Town',
  },
  {
    name: 'East End',
    value: 'East End',
  },
  {
    name: 'George Town',
    value: 'George Town',
  },
  {
    name: 'North Side',
    value: 'North Side',
  },
  {
    name: 'Sister Island',
    value: 'Sister Island',
  },
  {
    name: 'West Bay',
    value: 'West Bay',
  },
]

export const BC_PLANS = [
  'bc_plus-5-thryv-m2m',
  'bc_pro-5-thryv-m2m',
  'bc_unlm-5-thryv-m2m',
  'bc_ent-6-thryv-m2m',
  'bc_ent-unlm-5-thryv-m2m',
  'bc-6-thryv-m2m',
]

export const MC_PLANS = [
  'mc_plus-5-thryv-m2m',
  'mc_pro-5-thryv-m2m',
  'mc_pro_enh-5-thryv-m2m',
]

export const GROWTH_PACKAGES = ['addon-5-mcexpangr', 'addon-5-mcstartgr']

export const THRYV_STARTER_CODES = [
  'mc_starter-5-thryv-m2m',
  'starter-5-thryv-annual',
]

export const RC_PLANS = ['rc_plus-5-thryv-m2m']

export const WC_PLANS = ['wc_plus-5-thryv-m2m']

export const KEAP_MAX_PLANS = ['keap_max-5-thryv-m2m']

export const SOCIAL_ADS_5_CODES = [
  'addon-socialadsbronze-5-m2m',
  'addon-socialadssilver-5-m2m',
  'addon-socialadsgold-5-m2m',
]

export const SOCIAL_ADS_4_CODES = [
  'addon-4-socialadsbronze-m2m',
  'addon-4-socialadssilver-m2m',
  'addon-4-socialadsgold-m2m',
]

export const KEAP_TIER_CODES = [
  'keap_max-5-thryv-infl-m2m',
  'keap_pro-5-thryv-m2m',
  'keap_max-5-thryv-part-m2m',
  'keap_ultimate-5-thryv-m2m',
  'keap_ultimate-5-thryv-part-m2m',
]

export const KEAP_FAMILY_CODES = [
  'keap_max-5-thryv-m2m',
  'keap_pro-5-thryv-m2m',
  'keap_ultimate-5-thryv-m2m',
  'keap_max-5-thryv-part-m2m',
  'keap_ultimate-5-thryv-part-m2m',
  'keap_max-5-thryv-annual',
  'keap_pro-5-thryv-annual',
  'keap_ultimate-5-thryv-annual',
  'keap_max-5-thryv-part-annual',
  'keap_ultimate-5-thryv-part-annual',
]

// ES/IT/IN/PH/VN/GR are PoC markets sold Keap-only, mirroring GB — GB's
// reduced catalog isn't a bug, it's because product_price only has GBP
// rows for Keap-family products (verified against ooe_stagingdb_dev).
// These 5 countries keep USD pricing, so catalog.js's formatItem() mirrors
// GB's availability directly (does this product have a GBP price row?)
// instead of adding new per-country data.
export const KEAP_ONLY_COUNTRIES = ['ES', 'IT', 'IN', 'PH', 'VN', 'GR']

export const NEW_CUSTOMER_INIT_MC = 'nci-mc'

export const NEW_CUSTOMER_INIT_BC = 'nci-bc'
export const DELAY_HIDE_IN_SEC = 7
export const NEW_RC_COUPON = 'rc_excl-intro-offer'
export const NEW_THRYV_LEAD_CODE = 'tl-mc-5-thryv-m2m'
export const NEW_THRYV_LEAD_TAX_CODE = 'tl-tax-5-thryv-m2m'
export const LEGACY_TL_CODES_FOR_NEW_ORDERS = [
  'tl-mc-5-thryv-m2m',
  'tl-5-thryv-m2m',
]
export const NEW_THRYV_LEAD_4_TAX_CODE = 'addon-4-tl-tax-m2m'
export const LEGACY_TL_4_CODES_FOR_NEW_ORDERS = [
  'addon-4-tl-mc-m2m',
  'addon-4-tl-m2m',
]
export const MC_PLAN_CODE_INITIALS = 'mc_'
export const MC_PLANS_CODE = ['mc_plus-5-thryv-m2m', 'mc_pro-5-thryv-m2m']
export const MC_PLUS_PLAN = 'mc_plus-5-thryv-m2m'
export const MC_PRO_PLAN = 'mc_pro-5-thryv-m2m'
export const NEW_SEO_PLAN = 'seobase-5-thryv-m2m'
export const NEW_SEO_ADDONS = ['addon-5-seokey-m2m', 'addon-5-seopb-m2m']
export const SEO_KEYWORD_MAX_QTY = 5
export const NEW_SEO_KEYWORD = {
  name: 'SEO Keywords',
  code: 'addon-5-seokey-m2m',
}
export const NEW_SEO_POWERBOOST = {
  name: 'AEO & SEO PowerBoost',
  code: 'addon-5-seopb-m2m',
}

export const GENERIC_CARD_LIST = [
  'addon-5-keap-500addmessagebundle-m2m',
  'addon-5-keap-advcrmdataimport',
  'addon-5-keap-advdatatransfer',
  'addon-5-keap-apicalls-500kmonth',
  'addon-5-keap-basiccrmdataimport',
  'addon-5-keap-businessline-local',
  'addon-5-keap-convrrtlp-lite',
  'addon-5-keap-convrrtlp-pro',
  'addon-5-keap-creditcardimport',
  'addon-5-keap-dedicatedip',
  'addon-5-keap-ecommercedataimport',
  'addon-5-keap-ecommercedatatransfer',
  'addon-5-keap-goldsvcpkg',
  'addon-5-keap-limitedecommerce-crmimport',
  'addon-5-keap-platinumplussvcpkg',
  'addon-5-keap-platinumpremiumsvcpkg',
  'addon-5-keap-platinumstdsvcpkg',
  'addon-5-keap-silversvcpkg',
  'addon-5-keap-askexpt-ot',
  'addon-5-keap-datarestore-ot',
  'addon-5-keapgsuitestd',
  'bc-6-thryv-m2m',
  'kp-zapier-750zaps-m2m',
  'vert_svcs-5-thryv-m2m',
  'addon-5-mcstartgr',
  'addon-5-mcexpangr',
  'addon-6-mc-socialcontentgen-m2m',
]

export const STAND_ALONE_CARD = [
  'addon-5-keap-500addmessagebundle-m2m',
  'addon-5-keap-advcrmdataimport',
  'addon-5-keap-advdatatransfer',
  'addon-5-keap-apicalls-500kmonth',
  'addon-5-keap-basiccrmdataimport',
  'addon-5-keap-businessline-local',
  'addon-5-keap-convrrtlp-lite',
  'addon-5-keap-convrrtlp-pro',
  'addon-5-keap-creditcardimport',
  'addon-5-keap-dedicatedip',
  'addon-5-keap-ecommercedataimport',
  'addon-5-keap-ecommercedatatransfer',
  'addon-5-keap-goldsvcpkg',
  'addon-5-keap-limitedecommerce-crmimport',
  'addon-5-keap-platinumplussvcpkg',
  'addon-5-keap-platinumpremiumsvcpkg',
  'addon-5-keap-platinumstdsvcpkg',
  'addon-5-keap-silversvcpkg',
  'addon-5-keap-askexpt-ot',
  'addon-5-keap-datarestore-ot',
  'addon-5-keapgsuitestd',
  'bc-6-thryv-m2m',
  'kp-zapier-750zaps-m2m',
  'vert_svcs-5-thryv-m2m',
  'addon-5-mcstartgr',
  'addon-5-mcexpangr',
  'addon-6-mc-socialcontentgen-m2m',
]

export const NON_REMOVABLE_PRODUCT_LIST = [
  'appmarket-5-thryv-m2m',
  'cc_basicpls-5-thryv-m2m',
  'cc_basicpls-5-thryv-m2m',
  'addon-5-keap-addons',
  'addon-5-keap-addons-legacy-m2m',
  'addon-5-keap-addons-annual',
  'addon-5-keap-addons-legacy-annual',
  'addon-5-signatures_usage',
  'app-websitebuilder',
  'rc-5-thryv-m2m',
  'thryvprfee',
  'thryvdesg2',
  'keap-ignite-thryvprfee',
  'ent-keap-included-contacts',
  'ent-keap-included-txtvoice',
  'ent-keap-included-user',
  'ent-5-gmb',
  'ent-5-website',
  'ent-5-reviewack',
  'ent-keap-included-contacts-annual',
  'ent-keap-included-txtvoice-annual',
  'ent-keap-included-user-annual',
]

export const PRODUCT_ICONS = [
  {
    name: 'Thryv Add-Ons',
    img: reverseOrangePlusIcon,
  },
  {
    name: 'Home Services',
    img: keapMaxIcon,
  },
  {
    name: 'Keap Add-Ons',
    img: reverseGreenPlusIcon,
  },
]

export const VALID_TLDS = [
  'com',
  'net',
  'org',
  'biz',
  'info',
  'io',
  'co',
  'us',
  'in',
  'uk',
  'ca',
  'au',
  'nz',
  'de',
  'fr',
  'jp',
  'cn',
  'es',
  'it',
]

export const FORBIDDEN_DOMAINS = [
  'google',
  'bing',
  'twitter',
  'facebook',
  'amazon',
]
export const ALLOWED_DOMAINS = [
  'yelp.com',
  'yellowpages.com',
  'yellowpages.com.au',
]

export const COUNTRY_LANG = {
  US: {languages: ['English', 'Spanish'], name: 'United States'},
  CA: {languages: ['English'], name: 'Canada'},
  AU: {languages: ['English'], name: 'Australia'},
  NZ: {languages: ['English'], name: 'New Zealand'},
  GB: {languages: ['English'], name: 'Great Britain'},
  BB: {languages: ['English'], name: 'Barbados'},
  KY: {languages: ['English'], name: 'Cayman Islands'},
}

export const REGIONS = {
  US: ['Coastal', 'Midwest', 'South', 'Inside', 'Inbound', 'PartnerChannel'],
}

export const PRODUCT_GROUPS = [
  'RestrictedAccess',
  'AEO & SEO',
  'ThryvLeads',
  'MarketingCenter',
  'BusinessCenter',
  'HomeServices',
  'Keap',
  'ThryvSocialPosts',
  'WorkforceCenter',
  'SocialAds',
]

export const CALL_TYPES = {
  Onboarding: 'Thryv Onboarding Call',
  Creative: 'Creative',
  ThryvSuccessServices: 'Thryv Success Services',
}

export const USER_ROLES = [
  'Default',
  'PartnerOps',
  'KeapPartner',
  'InfluencerOps',
]

export const OOE_ROLES = [
  'All',
  'Admin',
  'ClientCare',
  'DirectSales',
  'Inbound LC',
  'InsideDemo',
  'InsideDemoOnly',
  'InfluencerOps',
  'KeapPartner',
  'LeadConverter',
  'National',
  'PartnerOps',
  'Premise',
  'PremiseDemo',
  'PremisePilot',
  'Reseller',
  'ThryvOnly',
  'TSS',
  'VivialDemo',
  'Inside',
  'Australia',
  'AUSalesUsers',
  'NZSales',
  'NewZealandSales',
]

export const KEAP_FAMILY_ANNUAL_CODES = [
  'keap_max-5-thryv-annual',
  'keap_max-5-thryv-part-annual',
  'keap_pro-5-thryv-annual',
  'keap_ultimate-5-thryv-annual',
  'keap_ultimate-5-thryv-part-annual',
  'keap_max-infl-5-thryv-annual',
]

export const KEAP_FAMILY_LEGACY_CODES = [
  'keap_ultimate-legacy-5-thryv-part-m2m',
  'keap_ultimate-legacy-5-thryv-m2m',
  'keap_ultimate-legacy-5-thryv-m2m',
  'keap_pro-sandbox-5-thryv-m2m',
  'keap_pro-legacy-5-thryv-m2m',
  'keap_pro-free-5-thryv-m2m',
  'keap_mobile-5-thryv-m2m',
  'keap_max-sandbox-5-thryv-m2m',
  'keap_max-legacy-5-thryv-m2m',
  'keap_max-infl-legacy-5-thryv-m2m',
  'keap_max-free-5-thryv-m2m',
  'keap_max-classic-sandbox-5-thryv-m2m',
  'keap_max-classic-free-5-thryv-m2m',
  'keap_lite-sandbox-5-thryv-m2m',
  'keap_lite-free-5-thryv-m2m',
  'keap_free-trial-5-thryv-part-m2m',
  'keap_free-trial-5-thryv-m2m',
  'keap_0-free-trial-5-thryv-m2m',
]

export const KEAP_FAMILY_LEGACY_ANNUAL_CODES = [
  'keap_lite-sandbox-5-thryv-annual',
  'keap_max-classic-free-5-thryv-annual',
  'keap_max-classic-sandbox-5-thryv-annual',
  'keap_max-free-5-thryv-annual',
  'keap_max-infl-legacy-5-thryv-annual',
  'keap_max-legacy-5-thryv-annual',
  'keap_max-sandbox-5-thryv-annual',
  'keap_pro-legacy-5-thryv-annual',
  'keap_pro-free-5-thryv-annual',
  'keap_pro-sandbox-5-thryv-annual',
  'keap_ultimate-5-thryv-part-annual',
  'keap_ultimate-legacy-5-thryv-annual',
  'keap_ultimate-legacy-5-thryv-part-annual',
]

export const SOCIAL_ADS_BNI_PLAN_CODES = [
  'addon-5-social-bni-m2m',
  'addon-5-social-bni-annual',
  'addon-5-mktgsvcs-soci-annual', // GEP-6860
  'addon-5-mktgsvcs-ypcom-annual', // GEP-6860
  'seobase-5-thryv-bni-nt-m2m', // GEP-7185
]

// The Website Design Fee is a one-time charge embedded in the addon-4-website-*
// plan's setup_fee field in Recurly. The frontend generates a synthetic
// "<plan>-setupfee" code as a display-only cart item — it is NOT a real Recurly
// plan and must never be sent as a subscription to Recurly.
export const isWebsite4DesignFeePlanCode = code =>
  typeof code === 'string' &&
  code.startsWith('addon-4-website-') &&
  code.endsWith('-setupfee')

export const KEAP_ADDONS_PARENT_CODES = [
  'addon-5-keap-addons',
  'addon-5-keap-addons-legacy-m2m',
  'addon-5-keap-addons-annual',
  'addon-5-keap-addons-legacy-annual',
]

export const KEAP_ADDONS_PARENT_NON_LEGACY_CODES = [
  'addon-5-keap-addons',
  'addon-5-keap-addons-annual',
]
export const KEAP_ADDONS_PARENT_LEGACY_CODES = [
  'addon-5-keap-addons-legacy-m2m',
  'addon-5-keap-addons-legacy-annual',
]
export const KEAP_LEGACY_CONTACTS_CODES = [
  'addon-5-keap-legacy-contacts-annual',
  'addon-5-keap-legacy-contacts-m2m',
]

export const FREE_ACCOUNT_CODES = [
  'appmarket-5-thryv-m2m',
  'cc_basicpls-5-thryv-m2m',
  'cc_basic-5-thryv-m2m',
  'addon-5-signatures_usage',
  'app-websitebuilder',
]

export const MC_TRIAL_PLAN_CODES = [
  'mc_freetrial-5-thryv-m2m',
  'mc_starter-5-thryv-m2m',
  'mc_prov2-5-thryv-m2m',
  'mc_premier-5-thryv-m2m',
  'starter-5-thryv-annual',
  'signature-5-thryv-annual',
  'premier-5-thryv-annual',
  'signature_plus-5-thryv-m2m',
  'signature_plus-5-thryv-annual',
]
